import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LatestPosts from './components/LatestPosts';
import SinglePost from './components/SinglePost';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Headless WordPress React Uygulaması</h1>
        </header>
        <main>
          <Routes>
            <Route path="/" element={<LatestPosts />} />
            <Route path="/yazi/:slug" element={<SinglePost />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
